import { useOrderStore } from "~/stores/use-order-store";

export function LoadingProvider() {
  const { transferingItems } = useOrderStore();

  const isLoading = transferingItems;

  if (!isLoading) return null;

  return (
    <div className="absolute inset-0 bg-black/80 z-[999999] flex flex-col items-center justify-center">
      Loading...
    </div>
  );
}
